import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import Reveal from "./Reveal";
import { useT } from "../i18n/LanguageContext";
import { GUIDE_ITEMS } from "../data/guides";

export default function HomeGuides() {
  const t = useT();
  return (
    <section className="px-6 md:px-12 py-24 md:py-32 max-w-[1600px] mx-auto" data-testid="home-guides">
      <Reveal>
        <p className="overline mb-4">{t("home.guidesOverline")}</p>
        <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-6 mb-12">
          <h2 className="font-serif text-4xl sm:text-5xl tracking-tight font-light max-w-2xl">
            {t("home.guidesTitle")}
          </h2>
          <p className="text-white/50 text-sm max-w-md">{t("home.guidesSubtitle")}</p>
        </div>
      </Reveal>
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
        {GUIDE_ITEMS.map((g, i) => (
          <Reveal key={g.path} delay={(i % 3) * 0.08}>
            <Link
              to={g.path}
              data-testid={`home-guide${g.path}`}
              className="group block relative h-72 overflow-hidden"
            >
              <img
                src={g.image}
                alt={t(g.labelKey)}
                className="absolute inset-0 w-full h-full object-cover transition-transform duration-700 group-hover:scale-105"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/85 via-black/25 to-transparent" />
              <div className="absolute bottom-0 left-0 w-full p-6 flex items-center justify-between">
                <h3 className="font-serif text-xl font-light text-white">{t(g.labelKey)}</h3>
                <ArrowRight size={18} className="text-[#C5A059] group-hover:translate-x-1 transition-transform" />
              </div>
            </Link>
          </Reveal>
        ))}
      </div>
    </section>
  );
}
